import { locationIdSchema } from "@repo/api/schemas";
import { useLocation } from "@repo/data-store";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { CatalogDefinition, LocationEdit } from "@/features/catalog";

export const Route = createFileRoute("/catalog/locations/$locationId_/edit")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canRead("Location")) throw redirect({ to: "/catalog/locations" });
  },
  component: LocationEditRoute,
});

function LocationEditRoute() {
  const locationId = locationIdSchema.parse(Route.useParams().locationId);
  const { permissions } = Route.useRouteContext();
  const navigate = useNavigate();
  const { location, isLoading } = useLocation(locationId);
  const back = () => navigate({ to: "/catalog/locations/$locationId", params: { locationId } });

  if (isLoading) return <CatalogDefinition.Pending />;
  if (!location) {
    return <CatalogDefinition.NotFound label="Location" backTo="/catalog/locations" backLabel="Back to locations" />;
  }

  return (
    <LocationEdit
      key={locationId}
      location={location}
      canEdit={permissions.canWrite("Location")}
      onDone={back}
      onCancel={back}
    />
  );
}
